import * as Sentry from "@sentry/react";

const dsn = process.env.REACT_APP_SENTRY_DNS;

if (dsn) {
  Sentry.init({
    dsn: dsn,
    normalizeDepth: 5, // Profondeur réduite pour limiter la taille
    normalizeMaxBreadth: 20, // Max 20 éléments par array
    maxValueLength: 1000, // Max 1000 caractères par string
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
  });
} else {
  console.warn('Sentry DSN not found - Sentry is disabled');
}
